import { useMutation, useQueryClient } from 'react-query';

import { IntegrationType } from 'src/generated/mloop-graphql';

import { ApiVerb, apiPost } from 'src/utils/api';

import { QUERY_KEY } from './types';

interface KomboCreateLinkRequest {
  integration_tool?: string;
}

interface KomboCreateLinkResponse {
  link: string;
}

interface KomboActivateRequest {
  token: string;
  reconnect?: boolean;
}

interface KomboActivateResponse {
  integration_id: string;
}

async function komboCreateLink(request: KomboCreateLinkRequest): Promise<KomboCreateLinkResponse> {
  const response = await apiPost<KomboCreateLinkRequest, KomboCreateLinkResponse>(ApiVerb.KOMBO_CREATE_LINK, request);
  return response.data;
}

async function komboCreateReconnectLink(): Promise<KomboCreateLinkResponse> {
  const response = await apiPost<Record<string, never>, KomboCreateLinkResponse>(
    ApiVerb.KOMBO_CREATE_RECONNECT_LINK,
    {}
  );
  return response.data;
}

async function komboActivate(request: KomboActivateRequest): Promise<KomboActivateResponse> {
  const response = await apiPost<KomboActivateRequest, KomboActivateResponse>(ApiVerb.KOMBO_ACTIVATE, request);
  return response.data;
}

export function useKomboCreateLink() {
  return useMutation((request: KomboCreateLinkRequest) => komboCreateLink(request));
}

export function useKomboCreateReconnectLink() {
  return useMutation(() => komboCreateReconnectLink());
}

export function useKomboActivate() {
  const queryClient = useQueryClient();
  return useMutation((request: KomboActivateRequest) => komboActivate(request), {
    onSuccess: () => {
      queryClient.invalidateQueries([QUERY_KEY]);
      queryClient.invalidateQueries([QUERY_KEY, IntegrationType.Kombo]);
    },
  });
}
